import React from 'react';

const Modal = ({ modalData, updateModalData, children }) => {
  return (
    <div
      className={`modal-componenet modal ${
        modalData.isOpen ? 'is-active' : ''
      }`}
      style={{ zIndex: '400' }}
    >
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">{modalData.title}</p>
          <button
            className="delete"
            aria-label="close"
            onClick={() => {
              updateModalData({ isOpen: false });
            }}
          />
        </header>
        <section className="modal-card-body">
          {/*      <!-- Content ... --> */}
          {/*    
          
          <div className="control has-icons-left">
            <div className="select is-medium">
              <span className="icon is-medium is-right">
                <i className="fa fa-user" />
              </span>
              <select style={{ paddingRight: '3rem' }} defaultValue={'DEFAULT'}>
                <option value="DEFAULT">القارئ</option>
                <option>عبد الرحمان السديس</option>
                <option>الشاطبي</option>
              </select>
            </div>
          </div>*/}
          {modalData.data === '' && children ? (
            children
          ) : (
            <p>{modalData.data}</p>
          )}
        </section>
        <footer className="modal-card-foot">
          {/* <button className="button is-success">Save changes</button>*/}
          <button
            className="button"
            onClick={() => {
              updateModalData({ isOpen: false });
            }}
          >
            <span className="icon is-medium">
              <i className="fa fa-close" />
            </span>
            <span>غلق</span>
          </button>
        </footer>
      </div>
    </div>
  );
};
const ModalType = {
  CHAPTER_INFO: 'CHAPTER_INFO',
  RECITER_INFO: 'RECITER_INFO',
  APP_FEEDBACK: 'APP_FEEDBACK',
  QURAN_INFO: 'QURAN_INFO',
  APP_HOW_TO_USE: 'APP_HOW_TO_USE',
  COMMUNICATE_WITH_US: 'COMMUNICATE_WITH_US',
  APP_ABOUT: 'APP_ABOUT'
};

export { Modal, ModalType };
